import { getCORSSafeURL } from "web-core/utils";
import {
  FlatPhoneFlag,
  MFD_ROLE_LABEL,
  useMarketingCreativeContext,
  MarketingFooterDisclaimer,
} from "@/modules/resources/components/marketing-creative-preview";

export function CalculatorBrandSection() {
  const {
    profile,
    branding,
    arn,
    contactFlagImageUrl,
    contactCallingCodeLabel,
    contactNationalNumber,
  } = useMarketingCreativeContext();

  const name = branding?.brand_name || profile?.name;

  return (
    <div className="mt-5 w-full">
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-3 w-full">
          <div className="flex min-w-0 items-center gap-2">
            {branding?.brand_logo ? (
              <div className="size-10 overflow-hidden rounded-lg shrink-0">
                <img
                  src={getCORSSafeURL(branding.brand_logo as string)}
                  alt={branding?.brand_name}
                  className="size-full object-cover"
                />
              </div>
            ) : null}
            <div className="min-w-0">
              <div className="line-clamp-1 text-xs font-semibold">{name}</div>
              <div className="line-clamp-2 text-[10px] opacity-60">
                {branding?.tag_line}
              </div>
            </div>
          </div>
          <div className="max-w-1/2 text-right shrink-0">
            <div className="line-clamp-1 text-xs font-semibold">{arn}</div>
            <div className="line-clamp-2 text-[10px] opacity-60">
              {MFD_ROLE_LABEL}
            </div>
          </div>
        </div>
        <div className="flex items-end justify-between gap-3 w-full">
          <div
            className="flex min-w-0 items-center gap-2 text-xs font-semibold"
            aria-label={`${contactCallingCodeLabel} ${contactNationalNumber}`}
          >
            <span className="flex shrink-0 items-center gap-1 pl-0.5">
              <FlatPhoneFlag
                url={contactFlagImageUrl}
                className="h-2.5 w-3 rounded-xs"
              />
              <span>{contactCallingCodeLabel}</span>
            </span>
            <span className="min-w-0">{contactNationalNumber}</span>
          </div>
          <MarketingFooterDisclaimer className="text-[7px]" />
        </div>
      </div>
    </div>
  );
}
